export default __webpack_public_path__ + "static/SupremeLL-JumboItalic-7bbadce0079c94287f5075c22bc28c10.woff";